import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonResponse } from '../models';
import { Tenant } from '../models/tenant/tenant';

@Injectable({
	providedIn: 'root',
})
export class TenantService {
	constructor(private _http: HttpClient) {}

	getTenant(): Observable<CommonResponse<Array<Tenant>>> {
		return this._http.get<CommonResponse<Array<Tenant>>>(`/saml2_tenants`);
	}

	getTenantPublic(): Observable<CommonResponse<Array<Tenant>>> {
		return this._http.get<CommonResponse<Array<Tenant>>>(`/saml2_tenants/public`);
	}

	insertTenant(tenant: Tenant): Observable<CommonResponse<Tenant>> {
		return this._http.post<CommonResponse<Tenant>>(`/saml2_tenants`, tenant);
	}

	showTenant(id: string): Observable<CommonResponse<Tenant>> {
		return this._http.get<CommonResponse<Tenant>>(`/saml2_tenants/${id}`);
	}

	editTenant(id: string, tenant: Tenant): Observable<CommonResponse<boolean>> {
		return this._http.put<CommonResponse<boolean>>(`/saml2_tenants/${id}`, tenant);
	}

	deleteTenant(id: string): Observable<CommonResponse<boolean>> {
		return this._http.delete<CommonResponse<boolean>>(`/saml2_tenants/${id}`);
	}

	autoconfigureTenant(metadataUrl: string): Observable<CommonResponse<{
		idp_entity_id: string;
		idp_login_url: string;
		idp_logout_url: string;
		idp_x509_cert: string;
		idp_x509_cert_multi?: string[];
		name_id_format?: string;
		key?: string;
		identification_field?: string;
		relay_state_url?: string;
	}>> {
		return this._http.post<any>(`/saml2_tenants/autoconfigure`, { metadata_url: metadataUrl });
	}

	getSpTemplate(): Observable<CommonResponse<{
		sp_metadata_url: string;
		sp_acs_url: string;
		sp_sls_url: string;
		sp_login_url: string;
		firewall_rules: Array<{ direction: string; port: string; protocol: string; source_ip: string; dest_ip: string; description: string; endpoint: string }>;
	}>> {
		return this._http.get<any>(`/saml2_tenants/sp_template`);
	}

	getSpInfo(id: string): Observable<CommonResponse<{
		sp_metadata_url: string;
		sp_acs_url: string;
		sp_sls_url: string;
		sp_login_url: string;
		firewall_rules: Array<{ direction: string; port: string; protocol: string; source_ip: string; dest_ip: string; description: string; endpoint: string }>;
	}>> {
		return this._http.get<any>(`/saml2_tenants/${id}/sp_info`);
	}

	getAccessLogs(id: string, page: number = 1, perPage: number = 20, search: string = ''): Observable<CommonResponse<any>> {
		const params: Record<string, string | number> = { page, per_page: perPage };
		if (search?.trim()) {
			params['search'] = search.trim();
		}
		return this._http.get<any>(`/saml2_tenants/${id}/access_logs`, { params });
	}
}
